module.exports = __webpack_public_path__ + "static/media/logo-mobile.5cd6c333.png";